/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Table, Switch, Tag, Modal, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getUsers, updateUserStatus, changeUserPassword } from "../features/cutomers/customerSlice";
import { Image } from "antd";
import { Input } from "antd";
import { Select } from "antd";
import { IoSearchOutline } from "react-icons/io5";
import { message as msg } from "antd";

const Customers = () => {
  const [messageApi, contextHolder] = msg.useMessage();
  const [searchQuery, setSearchQuery] = useState("");
  const [pwdModalOpen, setPwdModalOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [submittingPwd, setSubmittingPwd] = useState(false);
  const [form] = Form.useForm();

  const handleInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const dispatch = useDispatch();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 1000,
    key: "",
    status: "",
  });

  // Fetch data on component mount and pagination change
  useEffect(() => {
    const { current, pageSize, key, status } = pagination;
    const skip = (current - 1) * pageSize;

    dispatch(getUsers({ limit: pageSize, skip, key: key, status: status }));
  }, [
    dispatch,
    pagination.current,
    pagination.pageSize,
    pagination.key,
    pagination.status,
  ]);

  const { isLoading, customers, total } = useSelector(
    (state) => state.customer
  );

  const handleTableChange = (pagination) => {
    setPagination({
      ...pagination,
      current: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  useEffect(() => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      total: total,
    }));
  }, [total]);

  const handleStatusChange = (checked, record) => {
    const newStatus = checked ? 1 : 2;
    dispatch(updateUserStatus({ id: record.id, data: { status: newStatus } }));
    messageApi.open({
      type: "success",
      content: "User status updated successfully",
    });
  };

  const handleNotificationChange = (checked, record) => {
    dispatch(
      updateUserStatus({
        id: record.id,
        data: { enable_notification: checked },
      })
    );
    messageApi.open({
      type: "success",
      content: `Notification is ${
        checked ? "enabled" : "disabled"
      } successfully`,
    });
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (text, record) => (
        <Image
          width={40}
          height={40}
          style={{ borderRadius: "50%" }}
          src={record.profile_pic_url}
          alt={`${record.first_name} ${record.last_name}`}
        />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      // sorter: (a, b) => a.name.length - b.name.length,
      render: (text, record) => `${record.first_name ?? ''} ${record.last_name ?? ''}`,
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Age",
      dataIndex: "age",
    },
    {
      title: "Gender",
      dataIndex: "gender",
      render: (gender) => gender === "male" ? "Male" : "Female",
    },
    {
      title: "Notification",
      dataIndex: "enable_notification",
      key: "enable_notification",
      render: (enable_notification, record) => (
        <Switch
          checked={enable_notification}
          onChange={(checked) => handleNotificationChange(checked, record)}
        />
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => (
        <span>
          <Switch
            checked={status === 1}
            onChange={(checked) => handleStatusChange(checked, record)}
          />
        </span>
      ),
    },
    {
      title: 'Email Verified',
      dataIndex: 'is_email_verified',
      key: 'is_email_verified',
      render: (_, { is_email_verified }) => (
        <Tag color={is_email_verified ? 'green' : 'red'} key={`${Math.random()}`}>
          {is_email_verified ? 'Yes': 'No'}
        </Tag>
      )
    },
    {
      title: 'Deleted',
      dataIndex: 'is_deleted',
      key: 'is_deleted',
      render: (_, { is_deleted }) => (
        <Tag color={is_deleted ? 'red' : 'green'} key={`${Math.random()}`}>
          {is_deleted ? 'Yes': 'No'}
        </Tag>
      )
    },
    {
      title: "Created at",
      render: (record) => {
        const date = new Date(record.createdAt);
        const formattedDate = date.toLocaleDateString("en-US", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        });
        return `${formattedDate}`;
      },
      key: "reportedAt",
    },
    {
      title: "Action",
      dataIndex: "",
      key: "x",
      render: (status, record) => (
        <>
        <a href={`/admin/profile/${record.id}`} target="_blank" rel="noopener noreferrer">
          View
        </a>
        <span style={{ margin: "0 10px" }}>|</span>
        <a onClick={(e) => { e.preventDefault(); setSelectedUserId(record.id); form.resetFields(); setPwdModalOpen(true); }}>
          Change Password
        </a>
        </>
      ),
    },
  ];

  // Handle key down events on search
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setPagination({
        ...pagination,
        current: 1,
        key: searchQuery,
      });
    }
  };

  /** Handle dorp down for status is changed call search */
  const handleChange = (value) => {
    console.log(`selected ${value}`);
    setPagination({
      ...pagination,
      current: 1,
      status: value,
    });
  };

  return (
    <div>
      {contextHolder}
      <Modal
        title="Change Password"
        open={pwdModalOpen}
        onCancel={() => setPwdModalOpen(false)}
        onOk={() => form.submit()}
        confirmLoading={submittingPwd}
        okText="Change Password"
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={async (values) => {
            if (!selectedUserId) return;
            setSubmittingPwd(true);
            try {
              await dispatch(changeUserPassword({ id: selectedUserId, password: values.password })).unwrap();
              messageApi.open({ type: "success", content: "Password changed successfully" });
              setPwdModalOpen(false);
            } catch (e) {
              const errMsg = e?.response?.data?.message || e?.message || "Failed to change password";
              messageApi.open({ type: "error", content: errMsg });
            } finally {
              setSubmittingPwd(false);
            }
          }}
        >
          <Form.Item
            name="password"
            label="Password"
            rules={[
              { required: true, message: "Please enter a password" },
              { min: 8, message: "Minimum 8 characters" },
            ]}
            hasFeedback
          >
            <Input.Password placeholder="Enter new password" />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            label="Confirm Password"
            dependencies={["password"]}
            hasFeedback
            rules={[
              { required: true, message: "Please confirm password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Passwords do not match"));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirm new password" />
          </Form.Item>
        </Form>
      </Modal>
      <div className="row-space-between">
        <h3 className="mb-4 title">Users</h3>
        <div className="my-row">
          <div className="mr-5">
            {/* <IoSearchOutline className="fs-4" /> */}
            <Input
              placeholder="Search users"
              value={searchQuery}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              prefix={<IoSearchOutline className="fs-4" />}
            />
          </div>

          <div>
            <Select
              defaultValue="all"
              style={{ width: 120 }}
              onChange={handleChange}
              options={[
                { value: "", label: "all" },
                { value: "1", label: "Active" },
                { value: "2", label: "In-Active" },
              ]}
            />
          </div>
        </div>
      </div>
      <p> {isLoading} </p>
      <div>
        <Table
          columns={columns}
          dataSource={customers}
          rowKey={(record) => record.id}
          onChange={handleTableChange}
          pagination={pagination}
          loading={isLoading}
        />
      </div>
    </div>
  );
};

export default Customers;
